<template>
  <v-footer class="footer">
    <div class="footer_section">
      <div class="content_footer">
        <div class="img_logo"></div>
        <div class="middle_content">
          <div class="middle_content_tittle">Sede San Isidro</div>
          <div class="middle_content_body">Av. Prescott 333, Lima, PE</div>
          <div class="middle_content_body">01 219 0150 / 01 219 0151</div>
          <div class="middle_content_body">idiomas.sanisidro@up.edu.pe</div>
        </div>
        <div class="middle_content">
          <div class="middle_content_tittle">Sede Miraflores</div>
          <div class="middle_content_body">Av. Benavides 1657, Lima, PE</div>
          <div class="middle_content_body">01 219 0152</div>
          <div class="middle_content_body">idiomas.miraflores@up.edu.pe</div>
        </div>
      </div>
      <div class="line_footer"></div>
      <div class="icons_footer">
        <div class="icons_text">
          © Copyright - Centro de Idiomas de la Universidad Pacífico 2020 -
          Versión
          {{ applicationVersion }}
        </div>
        <!-- <div class="footer_icons">
                    <div v-for="item in items" :key="item.id">
                        <div
                            class="icons_de_footer"
                            :style="{'background-image': 'url('+item.img+')' } "
                        ></div>
                    </div>
                </div> -->
      </div>
    </div>
  </v-footer>
</template>
<script>
import { version } from "../../../package.json";
export default {
  data: () => ({
    applicationVersion: version
  })
};
</script>
